import config from '../config';
import useAxios from './useAxios';

export default function useGetReferences() {
    const { request: getTournamentCategories } = useAxios({
        method: 'get',
        url: `${config.server.serviceHostPublic}${config.server.apiPublic.tournamentCategories.uri}`,
        params: {
            page_size: 50
        }
    });
    const { request: getSportCategories } = useAxios({
        method: 'get',
        url: `${config.server.serviceHostPublic}${config.server.apiPublic.sportCategories.uri}`,
        params: {
            page_size: 50
        }
    });
    const { request: getCities } = useAxios({
        method: 'get',
        url: `${config.server.serviceHostPublic}${config.server.apiPublic.cities.uri}`,
        params: {
            page_size: 50
        }
    });
    const { request: getRegions } = useAxios({
        method: 'get',
        url: `${config.server.serviceHostPublic}${config.server.apiPublic.regions.uri}`,
        params: {
            page_size: 50
        }
    });
    const { request: getCountries } = useAxios({
        method: 'get',
        url: `${config.server.serviceHostPublic}${config.server.apiPublic.countries.uri}`,
        params: {
            page_size: 50
        }
    });
    const { request: getClubs } = useAxios({
        method: 'get',
        url: `${config.server.serviceHostPublic}${config.server.apiPublic.clubs.uri}`,
        params: {
            page_size: 50
        }
    });
    const { request: getCourtCoverages } = useAxios({
        method: 'get',
        url: `${config.server.serviceHostPublic}${config.server.apiPublic.courtCoverages.uri}`,
        params: {
            page_size: 50
        }
    });
    const { request: getDirectors } = useAxios({
        method: 'get',
        url: `${config.server.serviceHostPublic}${config.server.apiPublic.directors.uri}`,
        params: {
            page_size: 50
        }
    });

    const { request: getTournaments } = useAxios({
        method: 'get',
        url: `${config.server.serviceHost}${config.server.api.tournaments.uri}`
    });

    const { request: getTournamentsTags } = useAxios({
        method: 'get',
        url: `${config.server.serviceHostPublic}${config.server.api.tournamentsTags.uri}`,
        params: {
            page_size: 50
        }
    });

    return {
        getTournamentCategories,
        getSportCategories,
        getCities,
        getRegions,
        getCountries,
        getClubs,
        getCourtCoverages,
        getDirectors,
        getTournaments,
        getTournamentsTags
    };
}
